import { render, staticRenderFns } from "./Filas.vue?vue&type=template&id=558c2df3&scoped=true"
import script from "./Filas.vue?vue&type=script&lang=js"
export * from "./Filas.vue?vue&type=script&lang=js"
import style0 from "./Filas.vue?vue&type=style&index=0&id=558c2df3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558c2df3",
  null
  
)

export default component.exports